//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import '@/mixins/global'
// import axios from 'axios'
// import WipReadiness from '../components/WIPReadiness'
import WithinLTNew from '../components/WithinLTNew'
import Distribution from '../components/Distribution'

import ReadinessBlockDocument from '../components/ReadinessBlockDocument'
import ReadinessBlockSample from '../components/ReadinessBlockSample'
import ReadinessBlockFabric from '../components/ReadinessBlockFabric'
import ReadinessBlockSew from '../components/ReadinessBlockSew'
import ReadinessBlockPack from '../components/ReadinessBlockPack'
import ReadinessBlockFC from '../components/ReadinessBlockFC'
import ReadinessBlockPattern from '../components/ReadinessBlockPattern'

export default {
  components: {
    // WipReadiness,
    WithinLTNew,
    Distribution,
    ReadinessBlockDocument,
    ReadinessBlockSample,
    ReadinessBlockFabric,
    ReadinessBlockSew,
    ReadinessBlockPack,
    ReadinessBlockFC,
    ReadinessBlockPattern
  },
  data () {
    return {
      tab: 'page00',
      UserAccessData: {}
    }
  },
  created () {
    // console.log('Create')
  },
  async mounted () {
    this.chkAuthen('', '')
    const getRole = this.getUserPublic()
    const getRoleArray = await Promise.all([getRole])
    this.UserAccessData = getRoleArray[0]
    console.log(this.UserAccessData)
    // console.log('Mounted')
  },
  methods: {
    goPage (pageName) {
      this.$router.replace({
        name: pageName
      })
    },
    exitApp () {
      this.$q
        .dialog({
          title: 'Confirm',
          message: 'Do you want to Exit?',
          cancel: true,
          persistent: true
        })
        .onOk(() => {
          // console.log('>>>> OK')
          this.$router.replace({
            name: 'signin'
          })
        })
        .onOk(() => {
          // console.log('>>>> second OK catcher')
        })
        .onCancel(() => {
          // console.log('>>>> Cancel')
        })
        .onDismiss(() => {
          // console.log('I am triggered on both OK and Cancel')
        })
    }
  }
}
